import { Column } from "@/components/Column";

import { PLAYYARD_WATER_SURFACES } from "@/lib/constants";

// Rain puddles on the lawn that mirror the sky; PlayyardRain ripples them.
export const PlayyardPuddles = () => {
  return (
    <>
      {PLAYYARD_WATER_SURFACES.puddles.map((puddle) => (
        <Column
          key={`${puddle.centerX.toString()}-${puddle.centerY.toString()}`}
          className="pointer-events-none absolute z-[5] rounded-[50%] opacity-80 shadow-[inset_0_2px_4px_rgb(0_0_0_/_0.2)]"
          style={{
            left: `${(puddle.centerX - puddle.radiusX).toString()}%`,
            top: `${(puddle.centerY - puddle.radiusY).toString()}%`,
            width: `${(puddle.radiusX * 2).toString()}%`,
            height: `${(puddle.radiusY * 2).toString()}%`,
            background:
              "linear-gradient(var(--yard-waterTop), var(--yard-waterBottom))",
          }}
        />
      ))}
    </>
  );
};
